export default ["lt", "en"]
